// import React from "react";
import Solutions from "../component/Solutions";
import React, { useState } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Tokenization() {


    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    return (
        <>
            <Helmet>
                <title>Asset Tokenization Solutions | Unlock Liquidity | Blockcryp</title>
                <meta
                    name="description"
                    content="Tokenize assets with Blockcryp to access global markets, boost liquidity, raise capital, and ensure transparency. Secure, efficient tokenization for any asset."
                />
                <meta
                    name="keywords"
                    content="asset tokenization services, liquidity through tokenization, global asset tokenization, interoperable digital assets, capital fundraising with tokens, tokenized asset platform, blockchain asset tokenization, secure digital asset solutions, real-world asset interoperability, tokenization for transparency"
                />
            </Helmet>
            {/* ---------- hreo section start ---------- */}
            <section className="token_hero space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h1 className="heading_h2 fw-bold">Asset <span className="text-primary"> Tokenization </span> Development Company</h1>
                                <p className="pera_txt">Asset Tokenization Development makes it possible by digitizing ownership for increased liquidity and transparency. Blockcryp, as a leading Asset Tokenization Development Company, excels in delivering trusted, customizable platforms that help businesses streamline capital raising and asset management.</p>
                                <button className="button theme_btn mt-lg-4 mt-0" type="submit">Contact Us</button>
                            </motion.div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/tokenization_hero.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/tokenization_hero.webp" alt="token hero" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- tokenization solution section start ---------- */}
            <section className="space40">
                <div className="container">

                    <div className="row g-4">
                        <div className="col-12 p-0">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center mb-3"
                            >
                                <>
                                    {splitTextToSpans("Business Benefits of Our Asset",)} <br className="d-md-block d-none" />
                                    {splitTextToSpans("  Tokenization Solutions", "text-primary")}
                                </>
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Maximized Liquidity</h5>
                                <p>Tokenization transforms illiquid assets into easily tradable digital tokens, unlocking liquidity for businesses and investors, enabling faster transactions across markets.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Asset Interoperability</h5>
                                <p>Our Asset Tokenization Platform enables seamless interaction between different blockchain platforms, allowing businesses to expand their ecosystem’s functionality effortlessly.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Access to Global Markets</h5>
                                <p>Tokenized assets break geographical barriers, granting businesses and investors worldwide easy access to investment opportunities, driving growth, diversification, and global participation.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Capital Access and Fundraising</h5>
                                <p>Asset tokenization simplifies fundraising by enabling fractional ownership, attracting a wider investor base, and accelerating capital inflow with transparent, blockchain-powered processes.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Improved Efficiency</h5>
                                <p>Automation through smart contracts and blockchain reduces intermediaries, minimizes errors, and accelerates transactions, boosting overall operational efficiency for asset management.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Increased Transparency</h5>
                                <p>Blockchain’s immutable ledger ensures every transaction is recorded and visible, enhancing trust, compliance, and accountability between businesses and investors.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- token model section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center mb-5"
                            >
                                <>
                                    {splitTextToSpans(" Our Prime Suite Asset ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Tokenization Services", "text-primary")}
                                </>
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Token Modeling</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Custom Token Framework :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We build customized token models that align with your asset’s value, purpose, and utility. Our <b> Asset Tokenization Platform </b> ensures economic efficiency, legal compliance, and a scalable architecture tailored to your business goals.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Strategic Ecosystem Build :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We craft token ecosystems designed for longevity, allowing businesses to tokenize real-world assets efficiently. As a trusted <b> Asset Tokenization Development Company, </b> we focus on growth, trust, and market sustainability from day one.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Compliance & Scalability :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our solutions ensure your token models are regulation-ready and built to scale globally. With our expert <b> Asset Tokenization Development Services, </b> you can confidently launch a compliant and future-proof tokenized ecosystem.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model1.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Security Audits section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model2.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                    className="heading_h3 fw-bold mb-4"
                                >Security Audits
                                </motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Security Audit Experts :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our team conducts in-depth security audits to detect weaknesses in smart contracts and tokenization layers. With our advanced <b> Asset Tokenization Company </b> approach, we ensure every asset is protected from vulnerabilities and cyber threats.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Strengthening Smart Code :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We reinforce smart contracts to ensure they perform securely and autonomously. Our <b> Asset Tokenization Development Solutions </b> focus on minimizing risk and building a trusted, transparent environment for your digital assets.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Trustworthy Infrastructure :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We secure your platform’s infrastructure and transaction logic to support long-term reliability. Our asset tokenization services create robust systems that build trust with investors and meet compliance expectations globally.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Creation section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract Creation
                            </motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Automated Smart Logic :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We develop self-executing, automated smart contracts that handle asset transfers with precision. With our <b> Asset Tokenization Development </b> expertise, we eliminate intermediaries and reduce manual errors, ensuring seamless trustless execution.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Transparent Transactions :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our smart contracts enable fully transparent and secure token transactions. Built on blockchain standards, our Asset Tokenization Services help businesses manage assets more efficiently and securely in decentralized environments.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Efficient Asset Control :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We empower businesses with smart contracts that streamline asset ownership and rights management. Through our powerful <b> Asset Tokenization Development Solutions, </b> you gain full control, speed, and reliability across token operations.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model3.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model3.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Blockchain Integration section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model4.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model4.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Blockchain Integration
                            </motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Seamless Platform Merge :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We ensure smooth integration of your token platform with current business systems, creating a unified infrastructure that supports operations without disruptions while boosting reliability and operational efficiency.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Chain Integration :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our solutions connect your platform to multiple blockchains, allowing wider accessibility, better scalability, and real-time compatibility across decentralized ecosystems—all with minimal technical friction.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Enhanced User Experience :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    By aligning backend integration with intuitive front-end interfaces, we deliver platforms that are not just powerful but easy to use—improving adoption, satisfaction, and long-term engagement across your user base.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Maintenance and Support section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Maintenance and Support</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Continuous Performance Care :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We provide real-time platform monitoring and system health checks to ensure smooth operation. This proactive support helps maintain performance, fix issues early, and keep your platform running efficiently over time.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Security & Compliance Watch :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our team continuously oversees your platform’s security layers and compliance standards, ensuring everything meets evolving regulations and preventing vulnerabilities before they impact your users or operations.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Long-Term Support Plans :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    From regular updates to technical assistance, we deliver complete post-launch support tailored to your growth. Our approach keeps your system stable, future-ready, and resilient without interrupting daily business.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model5.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model5.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Platform Deployment section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model6.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model6.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Platform Deployment
                            </motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Rigorous Platform Testing :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We conduct thorough testing of every feature and function to ensure a flawless, stable launch. Our <b> Asset Tokenization Platform </b> undergoes stress tests to guarantee maximum performance, security, and reliability at scale.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Market-Ready Deployment :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    From functionality checks to UX validation, we refine every aspect before going live. As a trusted <b> Asset Tokenization Development Company, </b> we deliver dependable, high-performing platforms tailored to your industry needs.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Security-First Delivery :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We prioritize secure deployment by eliminating bugs and safeguarding smart contract logic. Through our <b> Asset Tokenization Development Solutions, </b> you receive a compliant, secure, and user-friendly platform ready for market adoption.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Tokenization Roadmap section start ---------- */}
            <section className="space40">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-12 order-lg-1 order-2">
                            <div>
                                <motion.p
                                    className="pera_txt mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >ELITE ASSET TOKENIZATION ROADMAP
                                </motion.p>
                                <motion.h3
                                    className="heading_h3 fw-bold"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Roadmap to Our Elite <span className="text-primary"> Asset Tokenization Process </span></motion.h3>
                                <motion.p
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Explore our elite asset tokenization process—step-by-step guidance to transform real-world assets into secure, scalable digital tokens.</motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Asset Evaluation & Modeling :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >We assess your asset’s value, legal standing, and potential for tokenization. Then, we design a custom token model aligned with your goals, powered by our advanced <b> Asset Tokenization Platform. </b></motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Smart Contracts & Blockchain :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                > Secure, self-executing smart contracts are developed to manage ownership and compliance. We integrate the ideal blockchain, ensuring speed and scalability as a trusted <b> Asset Tokenization Company. </b></motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Compliance & Token Creation :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >We set up KYC/AML systems and align your project with global regulations. Once compliant, we mint your tokens securely, offering reliable <b> Asset Tokenization Services </b> to ensure trust and legality.</motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Interface & Platform Build :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                > We develop intuitive interfaces for managing, trading, and onboarding investors. Our streamlined <b> Asset Tokenization Solutions</b> ensure smooth operations and easy access to tokenized assets.</motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-0"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Security & Ongoing Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >  Each component undergoes strict testing and audits. After launch, we continue with updates, optimization, and compliance checks—making your platform secure and scalable.</motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/token/model7.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/token/model7.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- studies section start ---------- */}
            <section className="space80 services">
                <div className="container">
                    <motion.h2
                        className="heading_h3 fw-bold mb-4"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                        viewport={{ once: false, amount: 0.5 }}
                    >Asset Tokenization Case Studies
                    </motion.h2>
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img src="assets/images/token/crypto111.webp" alt="" className="w-100" />
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Athene Network - A Decentralized Platfrom
                            </motion.h3>
                            <motion.p
                                className="para_text"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Introducing the <b> Athene Network,</b> a revolutionary mining application designed to bring decentralized infrastructure to the forefront of <span className="text-primary fw-bold"> AI Development </span> and deployment.</motion.p>
                            <motion.button
                                class="button theme_btn mt-2 mt-lg-4" type="submit"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >View case</motion.button>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Crypto Financial Platform section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Tarality: All-in-One Crypto Financial Platform</motion.h3>
                            <motion.p
                                className="para_text"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Tarality is a versatile crypto platform offering services like Buy Crypto, BNPL, Borrow, Fixed Deposit, and INR Trade, along with unique features like Safe Trade, Request Token, and a robust referral system.</motion.p>
                            <motion.button
                                className="button theme_btn mt-2 mt-lg-4" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >View case</motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img src="assets/images/token/crypto222.webp" alt="" className="w-100" />
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- studies section start ---------- */}
            <section className="space80 services">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img src="assets/images/token/crypto333.webp" alt="" className="w-100" />
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >R-Games.Tech - a unique gaming experience</motion.h3>
                            <motion.p
                                className="para_text"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >R-Games.Tech is a blockchain-based gaming platform that empowers players with true asset ownership, play-to-earn rewards, and a decentralized, community-driven ecosystem designed to reshape the future of gaming.</motion.p>
                            <motion.button
                                className="button theme_btn mt-2 mt-lg-4" type="submit"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >View case</motion.button>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Industries section start ---------- */}
            <section className="space40">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center mb-5"
                            >
                                Industries We Serve
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Real Estate</h5>
                                <p>Revolutionize ownership in real estate and streamline investment opportunities through tokenization, maximizing liquidity. Increase ROI and allow global investment diversification with improved asset management.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Finance</h5>
                                <p>Boost transparency and streamline financial transactions, digital securities, and alternative investments. Reach a broader investor audience and drive innovation across the financial ecosystem with asset tokenization.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Healthcare</h5>
                                <p> <b> Asset tokenization development services </b> revolutionize healthcare by enabling secure data ownership, efficient medical record sharing and transparent funding, enhancing trust, access, and innovation across the healthcare ecosystem.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Supply Chain and Logistics</h5>
                                <p>Enhance traceability and efficiency in the supply chain industry by tokenizing assets like goods. Refine supply chain operations, and enable end-to-end visibility with blockchain-supported <b> Asset Tokenization Development Solutions.</b></p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Art and Collectibles</h5>
                                <p>Turn artwork, collectibles, and valuable items into digital assets, enabling fractional ownership, verified provenance, and broader access. Empower inclusive art investment and build a thriving community of passionate collectors and investors.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-bold">Intellectual Property</h5>
                                <p>Tokenize intellectual property rights securely, empowering creators to monetize innovations, simplify licensing, and protect assets. Revolutionize IP management through transparent, secure, and efficient digital representation on the blockchain.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space40">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. Why is asset tokenization important?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Asset tokenization increases liquidity, reduces entry barriers, enhances transparency, and enables global, 24/7 access to previously illiquid or high-value assets like real estate or fine art.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. How does tokenization of assets work?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Tokenization involves issuing blockchain-based tokens that represent ownership of a physical or digital asset, governed by smart contracts for secure, traceable, and automated transfer and validation.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. What is asset tokenization in blockchain?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Asset tokenization is the process of converting real-world assets like real estate, art, or equity into digital tokens on a blockchain, enabling fractional ownership, liquidity, and transparent trading.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. Can small investors participate in tokenized assets?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes. Tokenization significantly lowers entry barriers, allowing small investors to easily own fractions of high-value assets like real estate or art, enabling wider participation and diversified portfolios.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. How long does it take for asset tokenization development?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Depending on complexity and regulatory requirements, <b> Asset Tokenization Development </b> may take from a few weeks to several months, including planning, legal structuring, and blockchain development.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Solutions />
        </>
    );
}
